import React from "react"
import {TextModel} from "models/Text"
import {FilterIcon, FiltersMenuButton, FiltersMenuButtonText} from "./components"
import env from "../../../../../config/env"

interface Cashmere25FiltersMenuButtonProps {
    text: TextModel
    disableIcon: boolean
    openFiltersPanel: (event: React.MouseEvent<HTMLButtonElement>) => void
}

export const Cashmere25FiltersMenuButton = ({
    text,
    disableIcon,
    openFiltersPanel,
}: Cashmere25FiltersMenuButtonProps) => {
    return (
        <FiltersMenuButton data-testid="plp-filters-menu-btn" onClick={openFiltersPanel}>
            {!disableIcon && (
                <FilterIcon
                    src={`${env.REACT_APP_BLOB_STORAGE_PATH}/icons/pdp/brand/next/filter-m-default.svg`}
                    // alt={text.assetsAlt.closeIcon}
                    data-testid="plp-filters-menu-icon"
                />
            )}
            <FiltersMenuButtonText className="plp-filters-menu-text">{text.labels.filterMenu}</FiltersMenuButtonText>
        </FiltersMenuButton>
    )
}

export default Cashmere25FiltersMenuButton
